
import Vue from 'vue';
import Component from 'vue-class-component';
import {Action, Getter} from 'vuex-class';
import {KullaniciBilgileriCevap} from '@/plugins/uyap-plugin/uyap/KullaniciBilgileri';

/**
 * Açık UYAP oturumu bu hesaba ait değil.
 *
 * Görsel dil DevreKesiciDialog ile aynı, ton kritik (kırmızı): burası bir güvenlik
 * sınırı. Kullanıcı hesabını başkasına verip, o kişinin e-imzasıyla açılmış oturum
 * üzerinden işlem yaptırabilir; bu yüzden uyarı bilgilendirici değil ENGELLEYİCİ.
 *
 * Uyarıyı kapatmak işlemleri geri açmaz — kapı UyapRequest içinde, her istekte
 * yeniden değerlendiriliyor.
 */
@Component({})
export default class KimlikUyusmazligiDialog extends Vue {
  @Getter kimlikUyusmazligiUyarisi!: { zaman: number, sebep: 'hesap' | 'kart' } | null;
  @Getter uyapAvukatBilgileri!: KullaniciBilgileriCevap | undefined;
  @Action kimlikUyusmazligiUyarisiniKapat!: () => void;
  @Action connectToUyap!: (payload?: { force?: boolean }) => Promise<void>;

  deneniyor = false;

  get acik(): boolean {
    return this.kimlikUyusmazligiUyarisi !== null;
  }

  set acik(v: boolean) {
    // persistent dialog; kapatma yalnızca düğmelerden.
    if (!v) this.kapat();
  }

  get hesapTckn(): string | null {
    return sessionStorage.getItem('tckn');
  }

  get oturumTckn(): string | null {
    return this.uyapAvukatBilgileri?.tcKimlikNo ?? null;
  }

  kapat() {
    this.kimlikUyusmazligiUyarisiniKapat();
  }

  async yenidenBaglan() {
    this.deneniyor = true;
    try {
      // force: mevcut oturum "geçerli" görünse bile yeniden giriş yapılmalı —
      // sorun oturumun geçersizliği değil, YANLIŞ KİŞİYE ait olması.
      await this.connectToUyap({force: true});
    } catch (e) {
      console.error('Yeniden bağlanma denemesi başarısız.', e);
    } finally {
      this.deneniyor = false;
      this.kapat();
    }
  }
}
